import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DataTransferService {



  private var1: any;
  private var2: any;
  private array: any;

  constructor(){
    this.var1 =  new BehaviorSubject<Array<any>>([])
    this.var2 =  new BehaviorSubject<Array<any>>([])
    this.array =  new BehaviorSubject<Array<any>>([])
  }

  setDataVar1(opening:any) {
    this.var1.next(opening)
  }
  setDataVar2(opening:any) {
    this.var2.next(opening)
  }
  setDataArray(opening:any) {
    this.array.next(opening)
  }


  getVar1() {
    return this.var1;
  }

  getVar2() {
    return this.var2;
  }

  getArray() {
    return this.array;
  }
}
